/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — punctuation marks, dashes, and line breaks are ignored; only the vowel sounds in actual words are counted. You can punctuate your haiku however you like without it affecting the 5-7-5 count.`)
};

const es_syl_haiku_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — los signos de puntuación, los guiones y los saltos de línea se ignoran; solo se cuentan los sonidos vocálicos de las palabras reales. Puedes puntuar tu haiku como quieras sin que eso afecte al recuento 5-7-5.`)
};

const de_syl_haiku_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein — Satzzeichen, Gedankenstriche und Zeilenumbrüche werden ignoriert; gezählt werden nur die Vokallaute in tatsächlichen Wörtern. Du kannst dein Haiku beliebig mit Satzzeichen versehen, ohne dass sich das auf die 5-7-5-Zählung auswirkt.`)
};

const nl_syl_haiku_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee — leestekens, streepjes en regeleinden worden genegeerd; alleen de klinkerklanken in echte woorden worden geteld. Je kunt je haiku interpunctioneren zoals je wilt, zonder dat dit de 5-7-5-telling beïnvloedt.`)
};

const fr_syl_haiku_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non — les signes de ponctuation, les tirets et les sauts de ligne sont ignorés ; seuls les sons vocaliques des mots réels sont comptés. Vous pouvez ponctuer votre haïku comme bon vous semble sans que cela n'affecte le compte 5-7-5.`)
};

const it_syl_haiku_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — i segni di punteggiatura, i trattini e le interruzioni di riga vengono ignorati; vengono contati solo i suoni vocalici nelle parole reali. Puoi punteggiare il tuo haiku come preferisci senza che ciò influisca sul conteggio 5-7-5.`)
};

const pt_br2_syl_haiku_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — sinais de pontuação, travessões e quebras de linha são ignorados; apenas os sons vocálicos em palavras reais são contados. Você pode pontuar seu haiku como quiser, sem que isso afete a contagem 5-7-5.`)
};

const pt_syl_haiku_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — os sinais de pontuação, travessões e quebras de linha são ignorados; apenas os sons vocálicos nas palavras reais são contados. Pode pontuar o seu haiku como preferir, sem que isso afete a contagem 5-7-5.`)
};

const ja_syl_haiku_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。句読点やダッシュ、改行は無視され、実際の単語の母音の音のみがカウントされます。俳句の句読点は自由に使っても、5-7-5のカウントには影響しません。`)
};

const zh_syl_haiku_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会——标点符号、破折号和换行都会被忽略，只统计实际单词中的元音发音。你可以随意为俳句添加标点，不会影响5-7-5的音节统计。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_faq3_a", locale)
	if (locale === "en") return en_syl_haiku_faq3_a(inputs)
	if (locale === "es") return es_syl_haiku_faq3_a(inputs)
	if (locale === "de") return de_syl_haiku_faq3_a(inputs)
	if (locale === "nl") return nl_syl_haiku_faq3_a(inputs)
	if (locale === "fr") return fr_syl_haiku_faq3_a(inputs)
	if (locale === "it") return it_syl_haiku_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_faq3_a(inputs)
	if (locale === "pt") return pt_syl_haiku_faq3_a(inputs)
	if (locale === "ja") return ja_syl_haiku_faq3_a(inputs)
	return zh_syl_haiku_faq3_a(inputs)
};